import Vue from 'vue'
import App from './App.vue'
import router from './router';
import 'element-ui/lib/theme-chalk/index.css';

import {
  Carousel,
  CarouselItem,
  Input,
  Form,
  FormItem,
  Button
} from 'element-ui';

Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Input);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Button);
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')